<template>
  <div class="personas-settings">
    <section-title>{{ $t('view.settings.personas.title') }}</section-title>
    <div class="personas-settings__section personas-settings__basic-section editor-section">
      <div class="editor-section-description">{{ $t('view.settings.personas.description') }}</div>
      <personas-list/>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss">
.personas-settings {
  &__section {
    margin-bottom: 80px;
    position: relative;
    width: 34vw;
    min-width: 540px;
  }

  &__basic-section {
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
}
</style>
